/**
 * Shows a VideoCollection where the user may edit or add videos
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import VideoInput from './VideoInput';
import VideoView from './VideoView';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { connect } from 'react-redux';
import { add, remove, update } from '../actions/videoActions';

const TRANSITION_CONFIG = {
    timeout: { enter: 500, exit: 300 },
    classNames: 'fade-in',
};

export class VideoCollection extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        profileId: PropTypes.number.isRequired,
        videos: PropTypes.object,
    };

    onRemove = (profileId, video) => {
        this.props.dispatch(remove(profileId, video));
    };

    onAdd = (profileId, video) => {
        this.props.dispatch(add(profileId, video));
    };

    onUpdate = (profileId, video) => {
        this.props.dispatch(update(profileId, video));
    };

    render() {
        const profileId = this.props.profileId;
        const videoInput =
            this.props.videos.videos.length >= 2 ? null : (
                <CSSTransition {...TRANSITION_CONFIG}>
                    <div className="grid__unit">
                        <VideoInput
                            errorMsg={this.props.videos.errorMsg}
                            mode={this.props.videos.mode}
                            onAdd={this.onAdd}
                            profileId={profileId}
                        />
                    </div>
                </CSSTransition>
            );
        const onRemove = this.onRemove;
        const onUpdate = this.onUpdate;
        const mode = this.props.videos.mode;

        const videos = this.props.videos.videos.map((video) => (
            <CSSTransition {...TRANSITION_CONFIG} key={video.id}>
                <div className="grid__unit transitionable">
                    <VideoView
                        mode={mode}
                        onRemove={onRemove}
                        onUpdate={onUpdate}
                        profileId={profileId}
                        video={video}
                    />
                </div>
            </CSSTransition>
        ));

        return (
            <section>
                <div className="panel">
                    <h2>{i18n.video.title}</h2>
                </div>
                <TransitionGroup
                    className="grid t-grid grid--cols1to2"
                    component="div"
                >
                    {videos}
                    {videoInput}
                </TransitionGroup>
            </section>
        );
    }
}

export default connect(() => ({}))(VideoCollection);
